module.exports = __webpack_public_path__ + "media/images/riders/small/DEFAULT-fe2d34888e24dcd0a64532e588534f36.png";